import { getGlobals } from "storyblok/api"
import {
  getAllPracticeAreaCategories,
  getCategoryArchivePracticeAreas,
  getPracticeAreaArchive,
} from "storyblok/practiceAreas"
import { getCategoryArchivePracticeAreasApi } from "storyblok/practiceAreasApi"
import Meta from "components/Meta"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import ArchiveCard from "components/ArchiveCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { CardListSection } from "components/Archive/CardListSection"

export default function PracticeAreasArchive({ meta, story, items, categories, perPage, total, currentPage, archiveOrder }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-ignore="all">
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Practice Areas", href: "/practice-areas" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/practice-areas"
          categoryLinkPrefix="/practice-areas/category/"
          currentTab={{ name: "All", value: "all" }}
          list={
            <CardListSection
              key="all"
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              archiveOrder={archiveOrder}
              columns={4}
              handler={(params) => getCategoryArchivePracticeAreasApi(params)}
              Card={ArchiveCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  const { page: story, archiveOrder } = await getPracticeAreaArchive()
  const categories = await getAllPracticeAreaCategories()
  const { items, total, currentPage, perPage } = await getCategoryArchivePracticeAreas({ archiveOrder })

  return {
    props: {
      story: story ?? null,
      items: items ?? null,
      perPage,
      total,
      currentPage,
      archiveOrder,
      categories: categories ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
